import React, { useEffect, useState } from 'react'
import Moment from 'moment'
import { 
  Row,
  Col,
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup, Label, Input, FormText
} from 'reactstrap'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import { ExperiencesDefaultValue, ExperiencesFieldData } from '../../assets'

const FormContent = ({
  open,
  onLoadExperience,
  selectedStudentCV,
  
  onClose,
  onClickSubmit
}) => {

  const [ experienceFormData, onChangeExperienceData ] = useState( ExperiencesDefaultValue )

  useEffect(() => {
    if ( !open ){
      onChangeExperienceData( ExperiencesDefaultValue )
    }
  }, [open])

  const onChangeExperienceField = ( key, val ) => {
    let tmp = _.cloneDeep( experienceFormData )
    tmp[ key ] = val
    return onChangeExperienceData( tmp )
  }

  return (
    <Modal
      isOpen={ open }
      size={ 'xl' }>
      <ModalHeader toggle={() => onClose()}>{ `Create Experience` }</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <Row>
          {
            ExperiencesFieldData.map( item => (
              <Col key={ item.value } lg={ item.col || 12 }>
                <FormGroup>
                  { 
                    item.label && (
                      <Label>
                        { `${ item.label } ` }
                        { item.required && <span className="text-danger">*</span> }
                      </Label>
                  )}
                  {
                    item.type === 'select' && (
                      <Input
                        type={ item.type }
                        value={ experienceFormData[ item.value ] }
                        onChange={ e =>  onChangeExperienceField( item.value, e.target.value )}
                        >
                        <option value=""></option>
                        { 
                          item.options.map( option => (
                            <option key={ option.id } value={ option.id }>{ option.name }</option>
                          ))
                        }
                      </Input>
                    )
                  }
                  {
                    ( item.type !== 'select' && item.type !== 'date' ) && (
                      <Input
                        type={ item.type }
                        value={ experienceFormData[ item.value ] }
                        onChange={ e => onChangeExperienceField( item.value, e.target.value )}/>
                    )
                  }
                  {
                    item.type === 'date' && (
                      <DatePicker
                        className={ 'w-100' }
                        dateFormat="dd-MM-yyyy"
                        selected={ experienceFormData[ item.value ] }
                        onChange={ val => onChangeExperienceField( item.value, val )}
                      />
                    )
                  }
                  { item.subLabel && <FormText>{ item.subLabel }</FormText> }
                </FormGroup>
              </Col>
            ))
          }
          </Row>
        </Form>
        { onLoadExperience && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button 
          className="mr-2"
          disabled={ ExperiencesFieldData.some( item => item.required && !experienceFormData[ item.value ])}
          color={ 
            (ExperiencesFieldData.some( item => item.required && !experienceFormData[ item.value ])) 
              ? 'secondary' 
              : 'primary' 
          }
          onClick={() => {
            onClickSubmit({
              ... experienceFormData,
              student_cv_id: selectedStudentCV.student_cv.id,
              start_date: Moment( experienceFormData.start_date ).format(),
              end_date: Moment( experienceFormData.end_date ).format()
            })
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormContent